jQuery(".textwidget strong").text( (new Date).getFullYear() );